import classNames from 'classnames'
import React from 'react'

import useThemeSettings from 'customizer/theme/useThemeSettings'
import ArrowDown from 'icons/bold/52-Arrows-Diagrams/01-Arrows/arrow-down-1.svg'

import Translation from '../Translation'

import './SummaryDrawerFooter.scss'

export type SummaryDrawerFooterProps = {
  onClose: () => void
} & React.HTMLAttributes<HTMLDivElement>

const SummaryDrawerFooter = ({ onClose, className, ...rest }: SummaryDrawerFooterProps) => {
  const summaryDrawerStyle = useThemeSettings('summaryDrawer')

  return (
    <div className={classNames('summary-drawer__footer', className)} {...rest}>
      <button
        className="summary-drawer__footer-cta"
        onClick={onClose}
        style={{ color: summaryDrawerStyle.closeButtonColor }}
      >
        <ArrowDown className="summary-drawer__footer-icon" style={{ fill: summaryDrawerStyle.closeButtonColor }} />
        <Translation field="close" />
      </button>
    </div>
  )
}

export default SummaryDrawerFooter
